<pas-tabset [routerParam]="routerParamName" [paramMode]="'path'" (tabChange)="onChangingTab($event)">
  <pas-tab [id]="tabIds.PartsAgreements">
    <ng-template pasTabTitle>
      <b>{{ 'partsAgreement.tab' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-parts-agreements></app-parts-agreements>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="tabIds.AddPartsAgreement" [disabled]="addTabDisabledAndHidden" [hidden]="addTabDisabledAndHidden">
    <ng-template pasTabTitle>
      <b>{{ 'partsAgreement.add.tab' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-parts-agreement-add (onBtnCancel)="onBtnCancel()"></app-parts-agreement-add>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="tabIds.RecourseCriteria">
    <ng-template pasTabTitle>
      <b>{{ 'recourseCriteria.tab' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-recourse-criteria></app-recourse-criteria>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="tabIds.SupplierCondition">
    <ng-template pasTabTitle>
      <b>{{ 'supplierCondition.tab' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-supplier-condition></app-supplier-condition>
    </ng-template>
  </pas-tab>
</pas-tabset>
